module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./index.js"));
	}, "GetDetailsView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=GetDetailsView!./src/pages/Shop/Home/HealthButler/index.js
// module id = 1862
// module chunks = 367